import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForSubcontract extends BaseModelAPI {
	static entity = 'newobject1947';
	static entityName = 'pickingsupplyforsubcontract';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.pickingSupplyForSubcontractNumber = '';
			this.workOrderSupplySubcontractId = '';
			this.workOrderSupplySubcontract = {};
			this.documentStatusId = '';
			this.documentStatus = {};
			this.materialIssueDate = '';
			this.pickingSupplyForSubcontractDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.actionStatus = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}